module.exports = __webpack_public_path__ + "img/work3.b8ee9db2.gif";